import presentList from './modules/presentList';
import weekOverview from './modules/weekOverview';
import {createStore} from 'vuex';

const debug = import.meta.env.DEV;

export default createStore({
    modules: {
        presentList,
        weekOverview,
    },
    strict: debug,
});
